// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dotSelected {
  z-index: 5000;
  background-color: #666666;
  height: 40px;
  width: 40px;
  border-radius: 50%;
        padding: 10px;
        display: flex;
}

.dotYellow {
  background-color: #FFFF66;
  height: 40px;
  width: 40px;
  border-radius: 50%;
        padding: 10px;
        display: flex;
}

.dotGreen {
  background-color: lightgreen;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotRed {
  background-color: lightcoral;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotBlue {
  background-color: lightskyblue;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotGray {
  background-color: lightslategray;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.padLeft  {
  padding-left: 10px;
}

.tableDivSize {
  height: 200px;
  width: 290px;
  overflow: auto;
  overflow-x: hidden !important;
}
.tableClass {
  width: 100%;
}
.tableDivSizeDrawer {
  height: 30%;
  width: 100%;
  overflow: auto;
  overflow-x: hidden !important;
}
.tableDrawer {
  width: 100%;
}

.buttonBilumina {
  background-color:#f89624;
  color:white;
  margin: 10px;
  width:90px;
}

.mat-column-code {
  width: 40% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-nameSmall  {
  width: 50% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
th {
  text-overflow: ellipsis;
}
table {
  width: 100%;
  table-layout: fixed;
}

@media(max-width: 900px){

  .hideSmallDevice {
    display: none;
  }
}
@media(min-width: 900px){

  .hideBigDevice {
    display: none;
  }
}

.sidebarLtMd {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #f1f1f1;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  animation: slide-in 0.5s forwards;
  -webkit-animation: slide-in 0.5s forwards;
}

.sidebar {
  margin: 0;
  padding: 0;
  width: 300px;
  display:flex !important;
  background-color: #f1f1f1;
  position: fixed;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}
.contentLtMd {
  width: 100%;
  overflow-x: hidden;
}
.content {
  margin-left: 300px;
  width: 100%;
  display:flex !important;
  padding: 1px 16px;
  overflow-x: hidden;
}

.notSetYet {
  display: none;
}


#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

.dateFilter {
  width: 210px;
}

.heightForSmallDevices {
  height:80vh;
}

.heightForBigDevices {
  height:40vh;
}


@keyframes slide-in {
  0% {
    -webkit-transform: translateX(-100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/analiza/analiza.component.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;QACZ,aAAa;QACb,aAAa;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;QACZ,aAAa;QACb,aAAa;AACrB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE;IACE,aAAa;EACf;AACF;AACA;;EAEE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;AACF","sourcesContent":["\n.dotSelected {\n  z-index: 5000;\n  background-color: #666666;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n        padding: 10px;\n        display: flex;\n}\n\n.dotYellow {\n  background-color: #FFFF66;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n        padding: 10px;\n        display: flex;\n}\n\n.dotGreen {\n  background-color: lightgreen;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotRed {\n  background-color: lightcoral;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotBlue {\n  background-color: lightskyblue;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotGray {\n  background-color: lightslategray;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.padLeft  {\n  padding-left: 10px;\n}\n\n.tableDivSize {\n  height: 200px;\n  width: 290px;\n  overflow: auto;\n  overflow-x: hidden !important;\n}\n.tableClass {\n  width: 100%;\n}\n.tableDivSizeDrawer {\n  height: 30%;\n  width: 100%;\n  overflow: auto;\n  overflow-x: hidden !important;\n}\n.tableDrawer {\n  width: 100%;\n}\n\n.buttonBilumina {\n  background-color:#f89624;\n  color:white;\n  margin: 10px;\n  width:90px;\n}\n\n.mat-column-code {\n  width: 40% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-nameSmall  {\n  width: 50% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\nth {\n  text-overflow: ellipsis;\n}\ntable {\n  width: 100%;\n  table-layout: fixed;\n}\n\n@media(max-width: 900px){\n\n  .hideSmallDevice {\n    display: none;\n  }\n}\n@media(min-width: 900px){\n\n  .hideBigDevice {\n    display: none;\n  }\n}\n\n.sidebarLtMd {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background-color: #f1f1f1;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n  animation: slide-in 0.5s forwards;\n  -webkit-animation: slide-in 0.5s forwards;\n}\n\n.sidebar {\n  margin: 0;\n  padding: 0;\n  width: 300px;\n  display:flex !important;\n  background-color: #f1f1f1;\n  position: fixed;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n}\n.contentLtMd {\n  width: 100%;\n  overflow-x: hidden;\n}\n.content {\n  margin-left: 300px;\n  width: 100%;\n  display:flex !important;\n  padding: 1px 16px;\n  overflow-x: hidden;\n}\n\n.notSetYet {\n  display: none;\n}\n\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n.dateFilter {\n  width: 210px;\n}\n\n.heightForSmallDevices {\n  height:80vh;\n}\n\n.heightForBigDevices {\n  height:40vh;\n}\n\n\n@keyframes slide-in {\n  0% {\n    -webkit-transform: translateX(-100%);\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n  }\n}\n\n@-webkit-keyframes slide-in {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
